import axios from '@/plugins/axios';
import { endpoint } from '@/api/apiConstants';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';
import { cookieHelperUtils } from '@/utils/cookieHelper';
import { NewMailSecurityRequest } from '@/types/emailSerurity';

type Login = {
  emailAddress: string;
  password: string;
  token: string;
  version: '2' | '3';
};

type Setting = {
  uniqueKey: string;
  password: string;
  emailAddress: string;
  telCellular: string;
};

type Reissue = {
  emailAddress: string;
  telCellular: string;
};

type UserMenu = {
  firstname: string;
  lastname: string;
};

export const postAuthLogin = async (params: Login) => {
  const res = await axios.post(endpoint.authLogin, params);
  localStorage.setItem('accessToken', res.data.accessToken);
  localStorage.setItem('refreshToken', res.data.refreshToken);
  return res;
};
export const postAuthLogout = async () => {
  const res = await axios.post(endpoint.authLogout);
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  sessionStorage.removeItem('pending_filters');
  sessionStorage.removeItem('jobsearch_filters');
  sessionStorage.removeItem('jobsearch_sort');
  sessionStorage.removeItem('jobsearch_public_searchcond');
  sessionStorage.removeItem('jobsearch_public_searchcard');
  sessionStorage.removeItem('jobsearch_public_search_company');
  sessionStorage.removeItem('apply_sort');
  sessionStorage.removeItem('ordersInfoKey');
  
  // remove cookies except login email
  const cookieNames = [];
  for (const c in MYPAGE_CONSTANTS.COOKIE_TIMEOUT) {
    if (c === 'LOGIN_MAIL') {
      continue;
    }
    cookieNames.push(MYPAGE_CONSTANTS.COOKIE_TIMEOUT[c].NAME);
  }
  cookieNames.forEach(cName => {
    cookieHelperUtils.removeCookie(cName);
  });

  document.body.style.overflow = '';
  
  return res;
};

export const postPasswordReissue = async (params: Reissue) => {
  const res = await axios.post(endpoint.passwordReissue, params);
  return res.data;
};

export const putPasswordSetting = async (params: Setting) => {
  const res = await axios.put(endpoint.passwordSetting, params);
  return res.data;
};

export const postPasswordCheckKey = async (uniqueKey: string) => {
  const res = await axios.post(endpoint.passwordCheckKey, { uniqueKey });
  return res.data;
};

// メニュー表示制御
export const getUserMenu = async (): Promise<UserMenu> => {
  const res = await axios.get(endpoint.userMenu);
  return res.data;
};

// Mail Security
export const getMailSecurityInfo = async () => {
  const res = await axios.post(endpoint.getMailSecuirity);
  return res.data;
};

export const postMailSecurityUpdateKey = async (request: NewMailSecurityRequest) => {
  const res = await axios.post(endpoint.postMailSecuirityUpdateKey, request);
  return res.data;
};

export const postMailSecurityResend = async () => {
  const res = await axios.post(endpoint.postResendMailSecuirity);
  return res.data;
};

export const postMailSecurityVerify = async (keyAuth: string) => {
  const res = await axios.post(endpoint.postMailSecurityVerify, { keyAuth });
  return res.data;
};

export const postMailSecurityVerifyCp2 = async (keyAuth: string) => {
  const res = await axios.post(endpoint.postMailSecurityVerifyCp2, { keyAuth });
  return res.data;
};

export const postMailSecurityCheckKey = async (keyAuth: string) => {
  const res = await axios.post(endpoint.postMailSecurityCheckKey, { keyAuth });
  return res.data;
};

export const postMailSecurityVerifyWithPassword = async (keyAuth: string, password: string) => {
  const res = await axios.post(endpoint.postMailSecurityVerifyWithPassword, { keyAuth, password });
  return res.data;
};

export const getEmailAuthInfoByUniqueKey = async (uniqueKey: string) => {
  const res = await axios.post(endpoint.getEmailAuthInfoByUniqueKey, { uniqueKey });
  return res.data;
};

export const postLastLoginUpdate = async () => {
  const res = await axios.get(endpoint.postLastloginUpdate);
  return res.data;
};